module.exports = __webpack_public_path__ + "static/media/riley_kirk.a4d02a02.jpeg";